/* ==========================================================================
   BEN'SHOME HELP WIDGET

   Six topics, because "which size" was never the only question people arrive
   with. Someone chasing a parcel does not want a sizing quiz, and someone
   asking what the board is made of should not have to open a contact form.

   Everything here is answered from facts on file. Nothing is generated,
   nothing is guessed. Every number (orders, rating, count, since, returns,
   delivery) arrives from Theme settings through window.BH_HELP.facts, so the
   widget can never quote a figure the rest of the site has moved on from.

   Self-contained on purpose. It builds its own launcher and panel (.bhw with
   .bhw-launch and .bhw-panel), which the sticky dock may move into itself on
   small screens, so that structure must stay as it is.
   ========================================================================== */
(function(){
  if (window.__bhHelpLoaded) return;
  window.__bhHelpLoaded = true;
  if (!document.body) return;

  var CFG = window.BH_HELP || {};
  var URLS = {
    finder:  CFG.finder  || '/pages/find-my-size',
    guide:   CFG.guide   || '/pages/measuring-guide',
    contact: CFG.contact || '/pages/contact',
    track:   CFG.track   || '/pages/track-your-order',
    reviews: CFG.reviews || '/pages/reviews',
    about:   CFG.about   || '/pages/our-story',
    faq:     CFG.faq     || '/pages/faqs',
    warranty:CFG.warranty|| '/pages/warranty',
    shipping:CFG.shipping|| '/policies/shipping-policy',
    returns: CFG.returns || '/policies/refund-policy',
    stockist:CFG.stockist|| ''
  };
  var F = CFG.facts || {};

  function esc(s){
    return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){
      return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];
    });
  }
  var RETURNS  = esc(F.returns || '30 days');
  var DELIVERY = esc(F.delivery || 'about 5 business days');

  /* The one sentence that quotes numbers. It drops the rating half entirely
     when the rating setting is blank. */
  function companyFacts(){
    var s = 'Since then: over <b>' + esc(F.orders || '500,000') + ' orders</b>';
    if(F.rating && F.count){
      s += ', rated <b>' + esc(F.rating) + ' out of 5</b> from ' + esc(F.count) +
           (F.source ? ' ' + esc(F.source) : '') + (F.asOf ? ' (' + esc(F.asOf) + ')' : '');
    }
    return s + '.';
  }

  function withTopic(url, topic){
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'topic=' + topic;
  }

  var TOPICS = [
    {
      id: 'size',
      label: 'Which size fits my furniture',
      body:
        '<p>The size finder does the matching for you. Pick your furniture, then tap the width and the seat depth of the bare seat base. It shows you the one size made for those numbers.</p>' +
        '<p><b>One thing before you measure:</b> take the cushions off first. Measure the bare seat base, inside the arms and from the front edge straight back to the backrest. Cushions overhang the frame, so measuring them gives the wrong size.</p>' +
        '<p>If your seat is just under a range, the size finder picks the size for your exact width. Not sure? Send us your numbers and we\'ll confirm before you order.</p>',
      actions: [
        ['Find my size', URLS.finder, 'primary'],
        ['How to measure', URLS.guide],
        ['Send us your numbers', withTopic(URLS.contact, 'sizing')]
      ]
    },
    {
      id: 'product',
      label: 'The product and what it is made of',
      body:
        '<p><b>Solid wood panels</b> under a bound fabric cover, with finished edges and rounded corners, so bare wood never touches your upholstery. Not foam.</p>' +
        '<p><b>Holds 400 lb</b> across the product, over 280 lb on a single board.</p>' +
        '<p>It folds flat to ship and opens across the whole seat. Fitting takes a couple of minutes: lift the cushions off, lay the board flat on the seat base, put the cushions back. No tools, and nothing is attached to the sofa.</p>' +
        '<p><b>Worth being straight about:</b> it makes the seat firm and level. If you like to sink in, it is not for you. It won\'t fix flat foam, a cracked frame or broken springs.</p>',
      actions: [
        ['Warranty details', URLS.warranty],
        ['All the questions', URLS.faq],
        ['Find my size', URLS.finder, 'primary']
      ]
    },
    {
      id: 'order',
      label: 'Help with an order I placed',
      body:
        '<p>Tracking is emailed automatically the moment your order ships, so check your inbox and your spam folder first.</p>' +
        '<p>If something is wrong with the order, message us with your <b>order number</b> and we will pull it up. It is on your confirmation email and starts with a #.</p>' +
        '<p><b>Returns:</b> ' + RETURNS + '. Return postage is on you, and the refund goes out once it is back in good condition.</p>' +
        '<p><b>Warranty:</b> if the board itself cracks, splits or comes apart, send us a photo and we send a new one, for as long as you own it. There is nothing to ship back.</p>',
      actions: [
        ['Track my order', URLS.track, 'primary'],
        ['Message us', withTopic(URLS.contact, 'order')],
        ['Returns policy', URLS.returns]
      ]
    },
    {
      id: 'shipping',
      label: 'Shipping and delivery',
      body:
        '<p><b>Free shipping</b> to the lower 48, no minimum.</p>' +
        '<p>Usually arrives in <b>' + DELIVERY + '</b>. Tracking is emailed when it ships.</p>' +
        '<p>We ship to the <b>48 contiguous states and DC</b>. We do not currently ship to Alaska, Hawaii or military addresses.</p>',
      actions: [
        ['Shipping policy', URLS.shipping],
        ['Track my order', URLS.track],
        ['Ask us something', URLS.contact]
      ]
    },
    {
      id: 'where',
      label: 'Where else can I buy',
      body:
        '<p>Buying here is the most direct route: same product, same warranty, and our team handles it from start to finish.</p>' +
        '<p>We also sell on our marketplace storefront, which is where the ratings we show come from. If you already have an account there and prefer it, that is completely fine by us.</p>' +
        '<p>We are not sold through third-party resellers. If you see our boards somewhere we have not mentioned, the warranty may not apply, so message us and we will confirm.</p>',
      actions: URLS.stockist
        ? [['Our storefront', URLS.stockist], ['Read the reviews', URLS.reviews], ['Buy here', URLS.finder, 'primary']]
        : [['Read the reviews', URLS.reviews], ['Buy here', URLS.finder, 'primary'], ['Ask us', URLS.contact]]
    },
    {
      id: 'company',
      label: 'About BEN’SHOME',
      body:
        '<p>We started' + (F.since ? ' in ' + esc(F.since) : '') + ' to give people with a sagging sofa an option short of replacing it.</p>' +
        '<p>' + companyFacts() + '</p>' +
        '<p>The company is <b>' + esc(F.legal || 'DBZ WORKS INC.') + '</b>, based in Florida. Real people answer the messages.</p>',
      actions: [
        ['Our story', URLS.about],
        ['Read the reviews', URLS.reviews],
        ['Contact us', URLS.contact]
      ]
    }
  ];

  /* ---------- markup ---------- */
  var wrap = document.createElement('div');
  wrap.className = 'bhw';
  wrap.innerHTML =
    '<button class="bhw-launch" type="button" aria-expanded="false" aria-controls="bhwPanel">' +
      '<span>Need a hand?</span></button>' +
    '<div class="bhw-panel" id="bhwPanel" role="dialog" aria-labelledby="bhwTitle" hidden>' +
      '<div class="bhw-head">' +
        '<button class="bhw-back" type="button" hidden aria-label="Back to topics">&#8592;</button>' +
        '<div><b id="bhwTitle">How can we help?</b><small>Real answers, no runaround</small></div>' +
        '<button class="bhw-x" type="button" aria-label="Close help">&#215;</button>' +
      '</div>' +
      '<div class="bhw-body"></div>' +
      '<p class="bhw-foot">Anything not covered here, a person will answer.</p>' +
    '</div>';
  document.body.appendChild(wrap);

  var launch = wrap.querySelector('.bhw-launch');
  var panel  = wrap.querySelector('.bhw-panel');
  var body   = wrap.querySelector('.bhw-body');
  var back   = wrap.querySelector('.bhw-back');
  var close  = wrap.querySelector('.bhw-x');
  if(!launch || !panel || !body || !back || !close) return;

  function menu(focusFirst){
    back.hidden = true;
    body.innerHTML = '<ul class="bhw-menu">' + TOPICS.map(function(t){
      return '<li><button type="button" data-topic="' + t.id + '">' + esc(t.label) + '</button></li>';
    }).join('') + '</ul>';
    if(focusFirst){
      var first = body.querySelector('button');
      if(first) first.focus();
    }
  }

  function show(id){
    var t = TOPICS.filter(function(x){ return x.id === id; })[0];
    if(!t) return;
    back.hidden = false;
    body.innerHTML =
      '<h2 class="bhw-title" tabindex="-1">' + esc(t.label) + '</h2>' +
      '<div class="bhw-copy">' + t.body + '</div>' +
      '<div class="bhw-actions">' + t.actions.map(function(x){
        return '<a class="btn ' + (x[2] === 'primary' ? 'btn-primary' : 'btn-secondary') +
               '" href="' + esc(x[1]) + '">' + esc(x[0]) + '</a>';
      }).join('') + '</div>';
    var h = body.querySelector('.bhw-title');
    if(h) h.focus();
    if (typeof window.bhTrack === 'function') window.bhTrack('bh_help_topic', {topic: id});
  }

  function open(on){
    panel.hidden = !on;
    launch.setAttribute('aria-expanded', on ? 'true' : 'false');
    if(on){
      menu(true);
      if (typeof window.bhTrack === 'function') window.bhTrack('bh_help_open', {});
    }
  }

  launch.addEventListener('click', function(){ open(panel.hidden); });
  close.addEventListener('click', function(){ open(false); launch.focus(); });
  back.addEventListener('click', function(){ menu(true); });
  body.addEventListener('click', function(e){
    var b = e.target && e.target.closest && e.target.closest('button[data-topic]');
    if(b) show(b.getAttribute('data-topic'));
  });
  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape' && !panel.hidden){ open(false); launch.focus(); }
  });
})();
